module.exports = __webpack_public_path__ + "static/media/link_expired.06a2e37e.png";